export function getRoleHome(user) {
  const accountType = String(user?.account_type || "").toUpperCase();
  if (user?.is_superuser || user?.is_platform_staff || ["SUPER_ADMIN", "ADMIN", "SUPPORT", "FINANCE", "OPERATIONS"].includes(accountType)) return "/portal";
  if (accountType === "SELLER") return "/portal/store";
  if (accountType === "BUSINESS") return "/portal/business";
  if (accountType === "COURIER") return "/portal/transport";
  return "/portal";
}

export function safePostAuthDestination(user, nextPath) {
  const clean = decodeURIComponent(nextPath || "").trim();
  const accountType = String(user?.account_type || "").toUpperCase();
  const isPublicBuyingPath = /^\/products\/[^/]+/.test(clean);
  const isBuyerRequestPath = clean === "/request";
  const isPublicBrowsePath = clean === "/" || /^\/categories\/[^/]+/.test(clean) || clean === "/transporters";
  const isSharedPortalTool = clean === "/portal/ai";

  // Keep marketplace product intent after login/register so a buyer can continue the purchase.
  if ((isPublicBuyingPath || isBuyerRequestPath) && accountType === "BUYER") return clean;

  // Public browsing pages and shared portal tools are safe after login.
  // Role-specific workspaces still fall back to each account's own home to avoid stale redirects between users.
  if (isPublicBrowsePath || isSharedPortalTool) return clean;

  return getRoleHome(user);
}
